<template>
    <div class="task">
        <div class="bar todo"></div>
        <div class="body">
            <div class="actions">
                <button type="button" rel="tooltip" title="" class="btn btn-link" data-original-title="Add Task" v-on:click="createTask">
                    <i class="tim-icons icon-simple-add"></i>
                </button>
            </div>
            <div class="form-group" style="max-width:500px;">
                <autocomplete :search="search" placeholder="Category" ref="categoryInput" :get-result-value="getResultValue"></autocomplete>
            </div>
            <div class="form-group" style="max-width:500px;">
                <input type="text" v-model="text" v-on:keyup.enter="createTask()" class="form-control" placeholder="Title...">
            </div>
            <div class="form-group" style="max-width:500px;">
                <input type="text" v-model="desc" v-on:keyup.enter="createTask()" class="form-control" placeholder="Description...">
            </div>
        </div>
        <div style="clear:both;"></div>
    </div>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue'

export default {
    name: 'taskcreate',
    data() {
        return {
            text: '',
            desc: '',
            category: ''
        }
    },
    components: {
        Autocomplete
    },
    props: ['task', 'categories'],
    methods: {
        search(input) {
            if (input.length < 1) { return [] }
            return this.categories.filter(cat => {
                return cat.title.toLowerCase().indexOf(input.toLowerCase()) !== -1
            })
        },
        getResultValue(result){
            return result.title;
        },
        createTask: function(){
            let parent_id = this.task == null ? 0 : this.task.id;
            let categoryText = this.$refs.categoryInput.value;
            this.$emit('on-create', this.text, categoryText, this.desc, parent_id);
            this.text = '';
            this.desc = '';
            this.category = '';
        }
    }
}
</script>
